import styled from 'styled-components';

export const FormContainer = styled.div`
  padding: 10px 20px;
`;
